// extracted by mini-css-extract-plugin
export default {"Action":"Container_Action__UxC+C","Wrapper":"Container_Wrapper__IWt-6","Table":"Container_Table__SN4Lc","TableHeader":"Container_TableHeader__TqFyb"};